/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { Button } from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import styles from './styles/main.scss';

const propTypes = {
  options: React.PropTypes.array.isRequired,
  disabled: React.PropTypes.bool,
  multiple: React.PropTypes.bool,
  onChange: React.PropTypes.func,
  bsSize: React.PropTypes.string,
  bsStyle: React.PropTypes.string,
};

const defaultProps = {
  bsStyle: 'aisz-primary',
  multiple: false,
};

class SelectPills extends React.Component {

  static parseSelected(options) {
    const selected = [];
    options.forEach((opt) => {
      if (opt.active) {
        selected.push(opt.value);
      }
    });
    return selected;
  }

  constructor(props) {
    super(props);
    this.state = {
      selected: SelectPills.parseSelected(props.options),
      disabled: props.disabled,
    };
    this.toggleSelect = this.toggleSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!_.eq(nextProps.disabled, this.props.disabled)) {
      this.setState({
        disabled: nextProps.disabled,
      });
    }
  }

  active(opt) {
    return this.state.selected.some(v => (v === opt.value));
  }

  toggleSelect(value) {
    const { multiple = false } = this.props;
    let { selected } = this.state;
    if (multiple) {
      if (selected.includes(value)) {
        selected = _.filter(selected, v => (v !== value));
        this.setState({ selected });
      } else {
        selected.push(value);
        this.setState({ selected });
      }
    } else {
      selected = [value];
      this.setState({ selected });
    }
    if (this.props.onChange) {
      this.props.onChange(selected);
    }
  }

  render() {
    const { bsStyle, bsSize, options } = this.props;
    const { disabled } = this.state;
    const opts = options.map(opt => (
      <Button
        key={opt.value}
        bsSize={bsSize}
        bsStyle={this.active(opt) ? bsStyle : 'aisz-light'}
        onClick={() => this.toggleSelect(opt.value)}
        disabled={disabled}
      >
        {opt.name}
      </Button>
    ));

    return (
      <div styleName="select-pills">
        {opts}
      </div>
    );
  }
}

SelectPills.propTypes = propTypes;
SelectPills.defaultProps = defaultProps;

export default CSSModules(SelectPills, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/components/SelectPills/index.jsx